<template>
    <div class="sponsor-banner__slide">
        <img :src="getImagePath" :alt="slide.image_title" class="sponsor-banner__image" >
        <div class="sponsor-banner__cta" :class="slide.image_title_position">
            <h2>{{ slide.image_title }}</h2>

            <a :href="slide.button_link" :target="hrefTarget" tabindex="1"> {{ slideButtonText }}</a>
        </div>
    </div>
</template>

<script>

    import helpers from '../../helpers';
    export default {

        props: {
            'slide': {required: true}
        },

        data: function(){
            return {
                helpers: helpers,
            }
        },

        computed: {
            getImagePath: function(){
                if(window.innerWidth < 621 && this.slide.mobile_image){
                    return this.slide.mobile_image
                }

                return this.slide.image;
            },
            hrefTarget () {
                return (this.slide.target_blank ? "_blank" : "_self")
            },
            slideButtonText: function(){
                if(this.slide.button_text){
                    return this.slide.button_text;
                }

                if(helpers.getLocale() === 'nl'){
                    return "MEER INFO"
                }

                return "MORE INFO";
            },
            getBackgroundImageStyleObject: function(){
                return (this.slide.mobile_image ? "backgroundStyleMobile" : "backgroundStyle")
            }
        }

    }
</script>

<style lang="scss" scoped>

    .sponsor-banner__slide{
        /*padding: 15px;*/
        /*margin-bottom: 20px;*/
        position: relative;
        // background-image: url(/site/img/artis.jpg);
        @media only screen and (max-width: 475px) {
            padding-left:0;
        }
    }

    .sponsor-banner__image{
        width:100%;
        @media only screen and (max-width: 500px) {
            min-height:180px;
        }
    }

    .sponsor-banner__cta{
        position: absolute;
        top: 0;
        bottom: 0;
        padding: 20px;
        width: 100%;
        h2 {
            color: white;
            line-height: 1.2em;
            text-transform: uppercase;
            max-width: 80%;

            @media only screen and (max-width: 620px) {
                font-size: 20px;
            }
        }
        a {
            z-index: 100;
            float: right;
            background: white;
            color:black;
            text-transform: uppercase;
            right: 55px;
            bottom: 53px;
            position: absolute;
            text-decoration: none;
            padding: 5px 8px;
        }
    }

    .left a{
        left: 35px;
        right: auto;
    }

    .right a {
        right: 55px;
        left: auto;
    }

    .middle a {
        left: 43%;
        right: auto;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/site/components/bhf-filter/bhf-special-filter-slide.vue